<template>
  <div v-if="data">
    <v-container fluid>
        <v-layout>
          <v-flex lg12 offset-lg0 xl10 offset-xl1>
            <v-layout row class="mb-2 px-2">
              <v-flex xs12>
                <v-breadcrumbs large class="ml-0 pl-2" v-if="data.innung">
                  <v-icon slot="divider">chevron_right</v-icon>
                  <v-breadcrumbs-item
                    :to="{ name: 'khdetail', params: { id: data.innung.kreishandwerkerschaft.slug }}" 
                    v-if="data.innung.kreishandwerkerschaft">
                      {{ data.innung.kreishandwerkerschaft.name }}
                  </v-breadcrumbs-item>
                  <v-breadcrumbs-item>
                    {{ data.innung.name }}
                  </v-breadcrumbs-item>
                </v-breadcrumbs>
              </v-flex>
            </v-layout>
            
    <v-layout row wrap v-if="data.innung" class="px-3">
      <v-flex xs12 md9 order-xs2 order-sm2 order-md1>
        <h1 :class="ÜberschriftSize">{{ data.innung.name }}</h1>
        <v-btn large
          class="text-none text-truncate mt-4" 
          :href="`${data.innung.url}`" target="_blank"
          v-if="data.innung.url"
          >Homepage&nbsp;<span class="hidden-xs-only">der {{ data.innung.name }}</span> <v-icon right>open_in_new</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs12 md2 offset-md1 class="px-0" :class="ResponsivePadding" order-sm1 order-md2 order-xs1 v-if="data.innung.logo">
        <div style="width: 100%;">
        <v-img :src="data.innung.logo" max-width="250px" class="elevation-12" ></v-img>   
        </div>    
      </v-flex>
    </v-layout>

  <v-container fluid v-if="data.innung.info">
    <v-layout >
      <v-flex xs12 lg9 v-html="data.innung.info" class="subheading"></v-flex>
    </v-layout>
  </v-container>

  <v-container  v-if="data.kalender">
    <v-layout>
      <v-flex v-if="sortedlimitMap" md12 lg10 offset-lg1 xl8 offset-xl2>
       <termin-liste :events="sortedlimitMap" :innung="this.data.innung"></termin-liste>
      </v-flex>
    </v-layout>
  </v-container>

      </v-flex>
    </v-layout>
</v-container>
 

<span v-if="data.betriebe">
  <v-container fluid>
      <v-layout>
        <v-flex lg12 offset-lg0 xl10 offset-xl1>
          <v-layout row class="px-3" v-if="data.innung">
              <v-flex xs6 >
              <h2 class="headline" id="landinghead">
                <strong>{{ this.data.betriebe.total }}</strong> Mitgliedsbetriebe gefunden
              </h2>
              </v-flex>
              <v-flex xs6 class="text-xs-right"> 
                <div class="headline" v-if="this.data.betriebe.last_page > 1">
                  <span v-if="ComputedPage">
                    Seite {{ ComputedPage }} von {{ this.data.betriebe.last_page }}
                  </span>
                </div>
              </v-flex>
            </v-layout>
        </v-flex>
      </v-layout>
  </v-container>

  <v-container fluid grid-list-lg>
    <v-layout>
      <v-flex lg12 offset-lg0 xl10 offset-xl1 style="z-index: 3;">
        <v-layout row wrap fill-height>
        <v-flex 
          xs12 
          sm6 
          md4 
          lg3
          grow
          v-for="betrieb in data.betriebe.data"
          :key="betrieb.id"
        >
          <landing-betrieb :betrieb="betrieb"></landing-betrieb>
        </v-flex>
      </v-layout>
      </v-flex>
    </v-layout>        
  </v-container>
  <div v-if="data.betriebe.last_page > 1">
    <v-container :style="SkylineMargin">
      <v-layout>
        <v-flex xs12 style="z-index: 3;">
          <div class="text-xs-center">
            <v-pagination
              v-model="ComputedPage"
              :length="data.betriebe.last_page"                
              :total-visible="$vuetify.breakpoint.xsOnly ? 5 : 10"
              @input="onPageChange()"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
  <div v-if="data.innung.kreishandwerkerschaft">
    <bottom-banner 
      v-if="data.innung.kreishandwerkerschaft.skyline" 
      :skyline="data.innung.kreishandwerkerschaft.skyline"
      :slug="data.innung.kreishandwerkerschaft.slug"
    ></bottom-banner>
</div>
</span>
</div>
</template>

<script>

import axios from 'axios'
import LandingBetrieb from '~/components/listing/ListingBetrieb.vue'
import BottomBanner from '~/components/kreishandwerkerschaften/BottomBanner.vue'

import TerminListe from '~/components/kalender/TerminListe.vue'

export default {
  metaInfo () {
    if (this.data) {
      return { title: this.data.innung.name }
    } else {
      return { title: 'Innung ' }
    }
  },
  components: {
    LandingBetrieb,
    TerminListe,
    BottomBanner
  },
  data: () => ({
    data: null,
    page: 1

  }),
  computed: {
    ComputedPage: {
      get: function () {
        let computedPage = 1
        if (this.$route.params.page) {
          computedPage = this.$route.params.page
          computedPage = parseInt(computedPage)
        }
        return computedPage
      },
      set: function (newValue) {
        // console.log(newValue)
        this.page = newValue
        // return computedPage
      }
    },
    // convert the list of events into a map of lists keyed by date
    eventsMap () {
      if (this.data.kalender) {
        const map = {}
        // this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
        if (this.data.kalender.length > 0) {
          for (const einzelkal of this.data.kalender) {
            if (einzelkal.events) {
              einzelkal.events.forEach(e =>
                (map[e.date] = map[e.date] || []).push(e)
              )
            }
          }
        }
        // console.log(map)
        return map
      }
    },
    limitMap () {
      if (this.data.kalender) {
        const eventCart = []
        if (this.data.kalender.length > 0) {
          const heute = new Date()
          for (const einzelkal of this.data.kalender) {
            if (einzelkal.events) {
              einzelkal.events.forEach(e => {
                if (new Date(e.date) >= heute) {
                  eventCart.push(e)
                }
              })
            }
          }
        }
        return eventCart
      }
    },
    ÜberschriftSize: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'headline'
      } else {
        return 'display-3'
      }
    },
    ResponsivePadding: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 'mb-5'
      } else if (this.$vuetify.breakpoint.name === 'sm') {
        return 'mb-3'
      } else {
        return 'mb-1'
      }
    },
    SkylineMargin: function () {
      if (this.data.innung.kreishandwerkerschaft) {
        if (this.data.innung.kreishandwerkerschaft.skyline) {
          return 'margin-bottom: -50px;'
        }
      } else {
        return 'margin-bottom: 30px;'
      }
    },
    sortedlimitMap () {
      if (this.limitMap) {
        this.limitMap.sort((a, b) => {
          const datum = new Date(a.date) - new Date(b.date)
          return datum
        })
        return this.limitMap.slice(0, 7)
      }
    }
  },
  mounted: function () {
  },

  beforeRouteEnter (to, from, next) {
    axios
      .get('/api/v1/innung/', {
        params: {
          slug: to.params.slug,
          page: to.params.page
        }
      })
      .then(resp => {
        // console.log('beforerouteenter')
        // console.log(resp)
        next(vm => (vm.data = resp.data))
      })
      .catch(error => {
        if (error.response.status === 404) {
          next({ name: '404' })
        }
        if (error.response) {
         // console.log(error.response)
        } else if (error.request) {
         // console.log('request putt')
        } else {
         // console.log('Error', error.message)
        }

        //  app.$router.push('/')
        next({ name: '404' })
      })
  },
  beforeRouteUpdate (to, from, next) {
    axios
      .get('/api/v1/innung/', {
        params: {
          slug: to.params.slug,
          page: to.params.page
        }
      })
      .then(resp => {
        this.setData(resp.data)

        next()
      })
      .catch(error => {
        if (error.response.status === 404) {
          next({ name: '404' })
        }
        if (error.response) {
          console.log('err response')
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        } else if (error.request) {
          // console.log('request putt')
          //   console.log(error.request);
        } else {
          console.log('Error', error.message)
        }

        //  app.$router.push('/')
        next('/404')
      })
  },
  methods: {
    setData (data) {
      this.data = data
      // this.data = Object.freeze(data)
    },
    onPageChange () {
      const context = this
      // console.log(context.page)
      // console.log(context.$route.params)
      this.$router.push({
        name: 'Innung',
        params: {
          slug: this.$route.params.slug,
          page: context.page
        }
      })
    }
  }
}

</script>
<style>
</style>